// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: Xi3_llZ3Sz6q
import * as React from "react";
import {
  PlasmicIcon as PlasmicIcon__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  renderPlasmicSlot,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import * as pp from "@plasmicapp/react-web";
import SelectState__Overlay from "../../SelectState__Overlay"; // plasmic-import: QdTqeupOwLyz/component
import SelectState__Option from "../../SelectState__Option"; // plasmic-import: Xn7o6HjeyNhf/component
import SelectState__OptionGroup from "../../SelectState__OptionGroup"; // plasmic-import: 6cQlIxw9scr2/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicSelectState.module.css"; // plasmic-import: Xi3_llZ3Sz6q/css
import ChevronDownSvgIcon from "./icons/PlasmicIcon__ChevronDownSvg"; // plasmic-import: B3NfmvoQPNM4/icon
import ChevronUpSvgIcon from "./icons/PlasmicIcon__ChevronUpSvg"; // plasmic-import: NOXSpKy5wnrC/icon

createPlasmicElementProxy;

export const PlasmicSelectState__VariantProps = new Array(
  "showPlaceholder",
  "isOpen",
  "isDisabled",
  "color"
);

export const PlasmicSelectState__ArgProps = new Array(
  "selectedContent",
  "placeholder",
  "children",
  "value",
  "name",
  "aria-label",
  "aria-labelledby",
  "options",
  "onChange"
);

const PlasmicSelectStateContext = React.createContext(undefined);

const $$ = {};

function PlasmicSelectState__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "showPlaceholder",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.showPlaceholder
      },
      {
        path: "isOpen",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.isOpen
      },
      {
        path: "isDisabled",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.isDisabled
      },
      {
        path: "color",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.color
      },
      {
        path: "value",
        type: "writable",
        variableType: "text",
        valueProp: "value",
        onChangeProp: "onChange"
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  return (
    <PlasmicSelectStateContext.Provider value={{ variants, args }}>
      <div
        data-plasmic-name={"root"}
        data-plasmic-override={overrides.root}
        data-plasmic-root={true}
        data-plasmic-for-node={forNode}
        className={classNames(
          projectcss.all,
          projectcss.root_reset,
          projectcss.plasmic_default_styles,
          projectcss.plasmic_mixins,
          projectcss.plasmic_tokens,
          plasmic_antd_5_hostless_css.plasmic_tokens,
          sty.root,
          {
            [sty.rootcolor_clear]: hasVariant($state, "color", "clear"),
            [sty.rootcolor_softBlue]: hasVariant($state, "color", "softBlue"),
            [sty.rootcolor_softCyan]: hasVariant($state, "color", "softCyan"),
            [sty.rootcolor_softGreen]: hasVariant($state, "color", "softGreen"),
            [sty.rootcolor_softOrange]: hasVariant(
              $state,
              "color",
              "softOrange"
            ),
            [sty.rootcolor_softPink]: hasVariant($state, "color", "softPink"),
            [sty.rootcolor_softPurple]: hasVariant(
              $state,
              "color",
              "softPurple"
            ),
            [sty.rootcolor_softRed]: hasVariant($state, "color", "softRed"),
            [sty.rootcolor_softYellow]: hasVariant(
              $state,
              "color",
              "softYellow"
            ),
            [sty.rootisOpen]: hasVariant($state, "isOpen", "isOpen")
          }
        )}
      >
        <button
          data-plasmic-name={"trigger"}
          data-plasmic-override={overrides.trigger}
          className={classNames(
            projectcss.all,
            projectcss.button,
            sty.trigger,
            {
              [sty.triggercolor_clear]: hasVariant($state, "color", "clear"),
              [sty.triggercolor_softBlue]: hasVariant(
                $state,
                "color",
                "softBlue"
              ),
              [sty.triggercolor_softCyan]: hasVariant(
                $state,
                "color",
                "softCyan"
              ),
              [sty.triggercolor_softGray]: hasVariant(
                $state,
                "color",
                "softGray"
              ),
              [sty.triggercolor_softGreen]: hasVariant(
                $state,
                "color",
                "softGreen"
              ),
              [sty.triggercolor_softOrange]: hasVariant(
                $state,
                "color",
                "softOrange"
              ),
              [sty.triggercolor_softPink]: hasVariant(
                $state,
                "color",
                "softPink"
              ),
              [sty.triggercolor_softPurple]: hasVariant(
                $state,
                "color",
                "softPurple"
              ),
              [sty.triggercolor_softRed]: hasVariant(
                $state,
                "color",
                "softRed"
              ),
              [sty.triggercolor_softYellow]: hasVariant(
                $state,
                "color",
                "softYellow"
              ),
              [sty.triggerisDisabled]: hasVariant(
                $state,
                "isDisabled",
                "isDisabled"
              ),
              [sty.triggerisOpen]: hasVariant($state, "isOpen", "isOpen"),
              [sty.triggershowPlaceholder]: hasVariant(
                $state,
                "showPlaceholder",
                "showPlaceholder"
              )
            }
          )}
          disabled={
            hasVariant($state, "isDisabled", "isDisabled") ? true : undefined
          }
          ref={ref => {
            $refs["trigger"] = ref;
          }}
        >
          <div
            data-plasmic-name={"contentContainer"}
            data-plasmic-override={overrides.contentContainer}
            className={classNames(projectcss.all, sty.contentContainer, {
              [sty.contentContainercolor_softBlue]: hasVariant(
                $state,
                "color",
                "softBlue"
              ),
              [sty.contentContainerisDisabled]: hasVariant(
                $state,
                "isDisabled",
                "isDisabled"
              ),
              [sty.contentContainershowPlaceholder]: hasVariant(
                $state,
                "showPlaceholder",
                "showPlaceholder"
              )
            })}
          >
            {(
              hasVariant($state, "showPlaceholder", "showPlaceholder")
                ? false
                : true
            )
              ? renderPlasmicSlot({
                  defaultContents: "Selected",
                  value: args.selectedContent,
                  className: classNames(sty.slotTargetSelectedContent, {
                    [sty.slotTargetSelectedContentcolor_softBlue]: hasVariant(
                      $state,
                      "color",
                      "softBlue"
                    ),
                    [sty.slotTargetSelectedContentcolor_softCyan]: hasVariant(
                      $state,
                      "color",
                      "softCyan"
                    ),
                    [sty.slotTargetSelectedContentcolor_softGreen]: hasVariant(
                      $state,
                      "color",
                      "softGreen"
                    ),
                    [sty.slotTargetSelectedContentcolor_softOrange]: hasVariant(
                      $state,
                      "color",
                      "softOrange"
                    ),
                    [sty.slotTargetSelectedContentcolor_softPink]: hasVariant(
                      $state,
                      "color",
                      "softPink"
                    ),
                    [sty.slotTargetSelectedContentcolor_softPurple]: hasVariant(
                      $state,
                      "color",
                      "softPurple"
                    ),
                    [sty.slotTargetSelectedContentcolor_softRed]: hasVariant(
                      $state,
                      "color",
                      "softRed"
                    ),
                    [sty.slotTargetSelectedContentcolor_softYellow]: hasVariant(
                      $state,
                      "color",
                      "softYellow"
                    ),
                    [sty.slotTargetSelectedContentisDisabled]: hasVariant(
                      $state,
                      "isDisabled",
                      "isDisabled"
                    ),
                    [sty.slotTargetSelectedContentisOpen]: hasVariant(
                      $state,
                      "isOpen",
                      "isOpen"
                    ),
                    [sty.slotTargetSelectedContentshowPlaceholder]: hasVariant(
                      $state,
                      "showPlaceholder",
                      "showPlaceholder"
                    )
                  })
                })
              : null}
            {(
              hasVariant($state, "showPlaceholder", "showPlaceholder")
                ? true
                : false
            )
              ? renderPlasmicSlot({
                  defaultContents: "Select\u2026",
                  value: args.placeholder,
                  className: classNames(sty.slotTargetPlaceholder, {
                    [sty.slotTargetPlaceholdercolor_softBlue]: hasVariant(
                      $state,
                      "color",
                      "softBlue"
                    ),
                    [sty.slotTargetPlaceholdercolor_softBlue_showPlaceholder]:
                      hasVariant(
                        $state,
                        "showPlaceholder",
                        "showPlaceholder"
                      ) && hasVariant($state, "color", "softBlue"),
                    [sty.slotTargetPlaceholdercolor_softCyan_showPlaceholder]:
                      hasVariant(
                        $state,
                        "showPlaceholder",
                        "showPlaceholder"
                      ) && hasVariant($state, "color", "softCyan"),
                    [sty.slotTargetPlaceholdercolor_softGreen_showPlaceholder]:
                      hasVariant(
                        $state,
                        "showPlaceholder",
                        "showPlaceholder"
                      ) && hasVariant($state, "color", "softGreen"),
                    [sty.slotTargetPlaceholdercolor_softOrange_showPlaceholder]:
                      hasVariant(
                        $state,
                        "showPlaceholder",
                        "showPlaceholder"
                      ) && hasVariant($state, "color", "softOrange"),
                    [sty.slotTargetPlaceholdercolor_softPurple_showPlaceholder]:
                      hasVariant($state, "color", "softPurple") &&
                      hasVariant($state, "showPlaceholder", "showPlaceholder"),
                    [sty.slotTargetPlaceholdercolor_softYellow_showPlaceholder]:
                      hasVariant(
                        $state,
                        "showPlaceholder",
                        "showPlaceholder"
                      ) && hasVariant($state, "color", "softYellow"),
                    [sty.slotTargetPlaceholdershowPlaceholder]: hasVariant(
                      $state,
                      "showPlaceholder",
                      "showPlaceholder"
                    ),
                    [sty.slotTargetPlaceholdershowPlaceholder_color_softPink]:
                      hasVariant(
                        $state,
                        "showPlaceholder",
                        "showPlaceholder"
                      ) && hasVariant($state, "color", "softPink"),
                    [sty.slotTargetPlaceholdershowPlaceholder_color_softRed]:
                      hasVariant(
                        $state,
                        "showPlaceholder",
                        "showPlaceholder"
                      ) && hasVariant($state, "color", "softRed")
                  })
                })
              : null}
          </div>
          <PlasmicIcon__
            data-plasmic-name={"dropdownIcon"}
            data-plasmic-override={overrides.dropdownIcon}
            PlasmicIconType={
              hasVariant($state, "isOpen", "isOpen")
                ? ChevronUpSvgIcon
                : ChevronDownSvgIcon
            }
            className={classNames(projectcss.all, sty.dropdownIcon, {
              [sty.dropdownIconcolor_softBlue]: hasVariant(
                $state,
                "color",
                "softBlue"
              ),
              [sty.dropdownIconcolor_softCyan]: hasVariant(
                $state,
                "color",
                "softCyan"
              ),
              [sty.dropdownIconcolor_softGray]: hasVariant(
                $state,
                "color",
                "softGray"
              ),
              [sty.dropdownIconcolor_softGreen]: hasVariant(
                $state,
                "color",
                "softGreen"
              ),
              [sty.dropdownIconcolor_softOrange]: hasVariant(
                $state,
                "color",
                "softOrange"
              ),
              [sty.dropdownIconcolor_softPink]: hasVariant(
                $state,
                "color",
                "softPink"
              ),
              [sty.dropdownIconcolor_softPurple]: hasVariant(
                $state,
                "color",
                "softPurple"
              ),
              [sty.dropdownIconcolor_softRed]: hasVariant(
                $state,
                "color",
                "softRed"
              ),
              [sty.dropdownIconcolor_softYellow]: hasVariant(
                $state,
                "color",
                "softYellow"
              ),
              [sty.dropdownIconisDisabled]: hasVariant(
                $state,
                "isDisabled",
                "isDisabled"
              ),
              [sty.dropdownIconisOpen]: hasVariant($state, "isOpen", "isOpen")
            })}
            role={"img"}
          />
        </button>
        {(hasVariant($state, "isOpen", "isOpen") ? true : false) ? (
          <SelectState__Overlay
            data-plasmic-name={"overlay"}
            data-plasmic-override={overrides.overlay}
            className={classNames("__wab_instance", sty.overlay, {
              [sty.overlayisOpen]: hasVariant($state, "isOpen", "isOpen")
            })}
            relativePlacement={"bottom"}
          >
            <div
              data-plasmic-name={"optionsContainer"}
              data-plasmic-override={overrides.optionsContainer}
              className={classNames(projectcss.all, sty.optionsContainer, {
                [sty.optionsContainerisOpen]: hasVariant(
                  $state,
                  "isOpen",
                  "isOpen"
                )
              })}
            >
              {renderPlasmicSlot({
                defaultContents: (
                  <React.Fragment>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__p9U1B
                      )}
                      value={"AL"}
                    >
                      {"Alabama"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__pbtQw
                      )}
                      value={"AK"}
                    >
                      {"Alaska"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option___3Jepu
                      )}
                      value={"AZ"}
                    >
                      {"Arizona"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option___0C9X
                      )}
                      value={"AR"}
                    >
                      {"Arkansas"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__tc3Hw
                      )}
                      value={"CA"}
                    >
                      {"California"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__kijev
                      )}
                      value={"CO"}
                    >
                      {"Colorado"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__vDIwJ
                      )}
                      value={"CT"}
                    >
                      {"Connecticut"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__jJq0X
                      )}
                      value={"DE"}
                    >
                      {"Delaware"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__lxcyb
                      )}
                      value={"DC"}
                    >
                      {"District of Columbia"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__fx9Ej
                      )}
                      value={"FL"}
                    >
                      {"Florida"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__rfgH2
                      )}
                      value={"GA"}
                    >
                      {"Georgia"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option___35Kzu
                      )}
                      value={"GU"}
                    >
                      {"Guam"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__crbZa
                      )}
                      value={"HI"}
                    >
                      {"Hawaii"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__bI1Ch
                      )}
                      value={"ID"}
                    >
                      {"Idaho"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__bVl5K
                      )}
                      value={"IL"}
                    >
                      {"Illinois"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option___4Ukx
                      )}
                      value={"ID"}
                    >
                      {"Idaho"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__jNzhy
                      )}
                      value={"IN"}
                    >
                      {"Indiana"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__j77Ob
                      )}
                      value={"IA"}
                    >
                      {"Iowa"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__ekJnz
                      )}
                      value={"KS"}
                    >
                      {"Kansas"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__nHy3I
                      )}
                      value={"KY"}
                    >
                      {"Kentucky"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__xxipa
                      )}
                      value={"LA"}
                    >
                      {"Louisiana"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__qpyPn
                      )}
                      value={"ME"}
                    >
                      {"Maine"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__rXoqk
                      )}
                      textValue={""}
                      value={"MH"}
                    >
                      {"Marshall Islands"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option___1FvZk
                      )}
                      value={"MD"}
                    >
                      {"Maryland"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__iNvLx
                      )}
                      value={"MA"}
                    >
                      {"Massachusetts"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option___8GIaQ
                      )}
                      value={"MI"}
                    >
                      {"Michigan"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__sRfba
                      )}
                      value={"MN"}
                    >
                      {"Minnesota"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__dbNoh
                      )}
                      value={"MS"}
                    >
                      {"Mississippi"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option___8BBm4
                      )}
                      value={"MO"}
                    >
                      {"Missouri"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__qu7BE
                      )}
                      value={"MT"}
                    >
                      {"Montana"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__qiMSr
                      )}
                      value={"NE"}
                    >
                      {"Nebraska"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option___2Swit
                      )}
                      value={"NV"}
                    >
                      {"Nevada"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__eJoEi
                      )}
                      value={"NH"}
                    >
                      {"New Hampshire"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__q8Mf8
                      )}
                      value={"NJ"}
                    >
                      {"New Jersey"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__gkmeM
                      )}
                      value={"NM"}
                    >
                      {"New Mexico"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__q96HY
                      )}
                      value={"NY"}
                    >
                      {"New York"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__dthhQ
                      )}
                      value={"NC"}
                    >
                      {"North Carolina"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__uRmYt
                      )}
                      value={"ND"}
                    >
                      {"North Dakota"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames("__wab_instance", sty.option__iG7E)}
                      value={"OH"}
                    >
                      {"Ohio"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__pmh3G
                      )}
                      value={"OK"}
                    >
                      {"Oklahoma"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__veqcq
                      )}
                      value={"OR"}
                    >
                      {"Oregon"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option___8PKcF
                      )}
                      value={"PA"}
                    >
                      {"Pennsylvania"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__odiDy
                      )}
                      value={"PR"}
                    >
                      {"Puerto Rico"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__t8Wgz
                      )}
                      value={"RI"}
                    >
                      {"Rhode Island"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames("__wab_instance", sty.option__lqZs)}
                      value={"SC"}
                    >
                      {"South Carolina"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__u16ZX
                      )}
                      value={"SD"}
                    >
                      {"South Dakota"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__kjVsh
                      )}
                      value={"TN"}
                    >
                      {"Tennessee"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__ev0OD
                      )}
                      value={"TX"}
                    >
                      {"Texas"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__qydIu
                      )}
                      value={"UT"}
                    >
                      {"Utah"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option___5SDhy
                      )}
                      value={"VT"}
                    >
                      {"Vermont"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__ypn1T
                      )}
                      value={"VI"}
                    >
                      {"Virgin Islands"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__stivt
                      )}
                      value={"VA"}
                    >
                      {"Virginia"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__tqQd5
                      )}
                      value={"WA"}
                    >
                      {"Washington"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option___1Cu0
                      )}
                      value={"WV"}
                    >
                      {"West Virginia"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__gh7Ja
                      )}
                      value={"WI"}
                    >
                      {"Wisconsin"}
                    </SelectState__Option>
                    <SelectState__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__sIn55
                      )}
                      value={"WY"}
                    >
                      {"Wyoming"}
                    </SelectState__Option>
                  </React.Fragment>
                ),

                value: args.children
              })}
            </div>
          </SelectState__Overlay>
        ) : null}
      </div>
    </PlasmicSelectStateContext.Provider>
  );
}

function useBehavior(props, ref) {
  if (!("options" in props)) {
    if (!("children" in props)) {
      props = {
        ...props,
        children: (
          <React.Fragment>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option__p9U1B)}
              value={"AL"}
            >
              {"Alabama"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option__pbtQw)}
              value={"AK"}
            >
              {"Alaska"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option___3Jepu)}
              value={"AZ"}
            >
              {"Arizona"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option___0C9X)}
              value={"AR"}
            >
              {"Arkansas"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option__tc3Hw)}
              value={"CA"}
            >
              {"California"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option__kijev)}
              value={"CO"}
            >
              {"Colorado"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option__vDIwJ)}
              value={"CT"}
            >
              {"Connecticut"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option__jJq0X)}
              value={"DE"}
            >
              {"Delaware"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option__lxcyb)}
              value={"DC"}
            >
              {"District of Columbia"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option__fx9Ej)}
              value={"FL"}
            >
              {"Florida"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option__rfgH2)}
              value={"GA"}
            >
              {"Georgia"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option___35Kzu)}
              value={"GU"}
            >
              {"Guam"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option__crbZa)}
              value={"HI"}
            >
              {"Hawaii"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option__bI1Ch)}
              value={"ID"}
            >
              {"Idaho"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option__bVl5K)}
              value={"IL"}
            >
              {"Illinois"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option___4Ukx)}
              value={"ID"}
            >
              {"Idaho"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option__jNzhy)}
              value={"IN"}
            >
              {"Indiana"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option__j77Ob)}
              value={"IA"}
            >
              {"Iowa"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option__ekJnz)}
              value={"KS"}
            >
              {"Kansas"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option__nHy3I)}
              value={"KY"}
            >
              {"Kentucky"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option__xxipa)}
              value={"LA"}
            >
              {"Louisiana"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option__qpyPn)}
              value={"ME"}
            >
              {"Maine"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option__rXoqk)}
              textValue={""}
              value={"MH"}
            >
              {"Marshall Islands"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option___1FvZk)}
              value={"MD"}
            >
              {"Maryland"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option__iNvLx)}
              value={"MA"}
            >
              {"Massachusetts"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option___8GIaQ)}
              value={"MI"}
            >
              {"Michigan"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option__sRfba)}
              value={"MN"}
            >
              {"Minnesota"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option__dbNoh)}
              value={"MS"}
            >
              {"Mississippi"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option___8BBm4)}
              value={"MO"}
            >
              {"Missouri"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option__qu7BE)}
              value={"MT"}
            >
              {"Montana"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option__qiMSr)}
              value={"NE"}
            >
              {"Nebraska"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option___2Swit)}
              value={"NV"}
            >
              {"Nevada"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option__eJoEi)}
              value={"NH"}
            >
              {"New Hampshire"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option__q8Mf8)}
              value={"NJ"}
            >
              {"New Jersey"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option__gkmeM)}
              value={"NM"}
            >
              {"New Mexico"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option__q96HY)}
              value={"NY"}
            >
              {"New York"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option__dthhQ)}
              value={"NC"}
            >
              {"North Carolina"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option__uRmYt)}
              value={"ND"}
            >
              {"North Dakota"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option__iG7E)}
              value={"OH"}
            >
              {"Ohio"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option__pmh3G)}
              value={"OK"}
            >
              {"Oklahoma"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option__veqcq)}
              value={"OR"}
            >
              {"Oregon"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option___8PKcF)}
              value={"PA"}
            >
              {"Pennsylvania"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option__odiDy)}
              value={"PR"}
            >
              {"Puerto Rico"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option__t8Wgz)}
              value={"RI"}
            >
              {"Rhode Island"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option__lqZs)}
              value={"SC"}
            >
              {"South Carolina"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option__u16ZX)}
              value={"SD"}
            >
              {"South Dakota"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option__kjVsh)}
              value={"TN"}
            >
              {"Tennessee"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option__ev0OD)}
              value={"TX"}
            >
              {"Texas"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option__qydIu)}
              value={"UT"}
            >
              {"Utah"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option___5SDhy)}
              value={"VT"}
            >
              {"Vermont"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option__ypn1T)}
              value={"VI"}
            >
              {"Virgin Islands"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option__stivt)}
              value={"VA"}
            >
              {"Virginia"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option__tqQd5)}
              value={"WA"}
            >
              {"Washington"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option___1Cu0)}
              value={"WV"}
            >
              {"West Virginia"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option__gh7Ja)}
              value={"WI"}
            >
              {"Wisconsin"}
            </SelectState__Option>
            <SelectState__Option
              className={classNames("__wab_instance", sty.option__sIn55)}
              value={"WY"}
            >
              {"Wyoming"}
            </SelectState__Option>
          </React.Fragment>
        )
      };
    }
  }
  return pp.useSelect(
    PlasmicSelectState,
    props,
    {
      ...{
        isOpenVariant: { group: "isOpen", variant: "isOpen" },
        placeholderVariant: {
          group: "showPlaceholder",
          variant: "showPlaceholder"
        },
        isDisabledVariant: { group: "isDisabled", variant: "isDisabled" },
        triggerContentSlot: "selectedContent",
        optionsSlot: "children",
        placeholderSlot: "placeholder",
        root: "root",
        trigger: "trigger",
        overlay: "overlay",
        optionsContainer: "optionsContainer"
      },
      OptionComponent: SelectState__Option,
      OptionGroupComponent: SelectState__OptionGroup
    },
    ref
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "trigger",
    "contentContainer",
    "dropdownIcon",
    "overlay",
    "optionsContainer"
  ],

  trigger: ["trigger", "contentContainer", "dropdownIcon"],
  contentContainer: ["contentContainer"],
  dropdownIcon: ["dropdownIcon"],
  overlay: ["overlay", "optionsContainer"],
  optionsContainer: ["optionsContainer"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicSelectState__ArgProps,
          internalVariantPropNames: PlasmicSelectState__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicSelectState__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicSelectState";
  } else {
    func.displayName = `PlasmicSelectState.${nodeName}`;
  }
  return func;
}

export const PlasmicSelectState = Object.assign(
  // Top-level PlasmicSelectState renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    trigger: makeNodeComponent("trigger"),
    contentContainer: makeNodeComponent("contentContainer"),
    dropdownIcon: makeNodeComponent("dropdownIcon"),
    overlay: makeNodeComponent("overlay"),
    optionsContainer: makeNodeComponent("optionsContainer"),
    // Metadata about props expected for PlasmicSelectState
    internalVariantProps: PlasmicSelectState__VariantProps,
    internalArgProps: PlasmicSelectState__ArgProps,
    // Context for sub components
    Context: PlasmicSelectStateContext,
    useBehavior
  }
);

export default PlasmicSelectState;
/* prettier-ignore-end */
